module.exports = require("zlib");


//////////////////
// WEBPACK FOOTER
// external "zlib"
// module id = 196
// module chunks = 0